import React, { useEffect, useState } from "react";
import { StickyNote, ChevronDown, ChevronUp } from "lucide-react";

/**
 * Per-step scratchpad — RN-only notes, never sent to backend or PDFs.
 * Persists in localStorage keyed by step id.
 */
export default function StepScratchpad({ stepId }) {
  const key = `wi-pa-scratch-step-${stepId}`;
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState("");

  useEffect(() => {
    try {
      const v = localStorage.getItem(key) || "";
      setValue(v);
    } catch {
      /* localStorage unavailable — non-fatal */
    }
  }, [key]);

  useEffect(() => {
    try { localStorage.setItem(key, value); } catch { /* localStorage full or unavailable — non-fatal */ }
  }, [key, value]);

  return (
    <div className="mt-6 rounded-xl border border-dashed border-[#e2b6a9] bg-[#FFFDEC]/70" data-testid={`scratch-${stepId}`}>
      <button
        type="button"
        onClick={() => setOpen((x) => !x)}
        className="w-full flex items-center justify-between px-4 py-2.5 text-[12.5px] font-semibold text-[#8A6B00]"
        data-testid={`scratch-${stepId}-toggle`}
      >
        <span className="inline-flex items-center gap-2">
          <StickyNote className="w-4 h-4" /> Scratchpad — private RN notes (never on PDFs)
        </span>
        {open ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}
      </button>
      {open && (
        <div className="px-4 pb-4">
          <textarea
            rows={3}
            value={value}
            onChange={(e) => setValue(e.target.value)}
            placeholder="e.g., 'Client declined sharing marital status — circle back next visit.'"
            className="tb-textarea bg-white"
            data-testid={`scratch-${stepId}-input`}
          />
          <div className="text-[11px] text-[#a07a27] mt-1">Stays on this device. Clears when you Reset the wizard.</div>
        </div>
      )}
    </div>
  );
}
